<template lang="pug">
//- Dialog de confirmação/ativação de um template de cupom (prévia).
//- Extraído de pages/cupom-desconto/Lista.vue para reuso na tela de Marketing.
v-dialog(v-model="aberto", max-width="420", persistent, v-if="cupomTemplateSelecionado")
  v-card.Poppins(style="border-radius:17px;overflow:hidden;")
    .templateConfirm__header(style="background-color: #fff;")
      .templateConfirm__title Confirmar ativação
      .templateConfirm__valor.Poppins
        span(v-if="cupomTemplateSelecionado.entrega_gratis") Grátis
        span(v-else-if="cupomTemplateSelecionado.tipo_desconto == 1") R${{ cupomTemplateSelecionado.valor_desconto }}
        span(v-else) {{ cupomTemplateSelecionado.valor_desconto }}%
      .templateConfirm__valor-label.Poppins
        span(v-if="cupomTemplateSelecionado.entrega_gratis") na entrega
        span(v-else-if="cupomTemplateSelecionado.tipo_desconto == 1") de desconto
        span(v-else) OFF no pedido
    .templateConfirm__rows
      .templateConfirm__row
        span.templateConfirm__row-label Código
        span.templateConfirm__row-value {{ cupomTemplateConfig.codigo.toUpperCase() }}
      .templateConfirm__row(v-if="cupomTemplateSelecionado.valor_minimo > 0")
        span.templateConfirm__row-label Pedido mínimo
        span.templateConfirm__row-value R${{ cupomTemplateSelecionado.valor_minimo }}
      .templateConfirm__row(v-if="cupomTemplateSelecionado.valor_desconto_maximo")
        span.templateConfirm__row-label Desconto máximo
        span.templateConfirm__row-value R${{ Number(cupomTemplateSelecionado.valor_desconto_maximo).toFixed(2).replace('.', ',') }}
      .templateConfirm__row
        span.templateConfirm__row-label Vigência
        span.templateConfirm__row-value {{ vigenciaLabel }}
      .templateConfirm__row
        span.templateConfirm__row-label Disponibilidade
        span.templateConfirm__row-value {{ cupomTemplateConfig.tipo_quantidade === 'mensal' ? 'Renovável mensalmente' : 'Uso único por usuário' }}
      .templateConfirm__row
        span.templateConfirm__row-label Por usuário
        span.templateConfirm__row-value 1x
      .templateConfirm__row(v-if="cupomTemplateSelecionado.entrega_gratis && cupomTemplateConfig.regraDescontoEntrega")
        span.templateConfirm__row-label Desc. máx. entrega
        span.templateConfirm__row-value(v-if="cupomTemplateConfig.regraDescontoEntrega === 'limitado'") R${{ Number(cupomTemplateConfig.valorDescontoMaximoEntrega).toFixed(2).replace('.', ',') }}
        span.templateConfirm__row-value(v-else) Sem limite
    //- Seleção da regra de desconto na entrega
    .templateConfirm__regra-entrega(v-if="cupomTemplateSelecionado && cupomTemplateSelecionado.entrega_gratis")
      .templateConfirm__regra-title Limite do desconto na entrega
      .templateConfirm__regra-hint Escolha o valor máximo de desconto na taxa de entrega
      v-progress-linear(v-if="loadingBairros", indeterminate, color="#1d9a5a", style="margin:12px 0;")
      .templateConfirm__regra-opcoes(v-else)
        button.templateConfirm__regra-btn(
          v-for="faixa in faixasDescontoEntrega",
          :key="faixa.valor",
          type="button",
          :class="{ 'templateConfirm__regra-btn--active': cupomTemplateConfig.regraDescontoEntrega === 'limitado' && cupomTemplateConfig.valorDescontoMaximoEntrega === faixa.valor }",
          @click="cupomTemplateConfig.regraDescontoEntrega = 'limitado'; cupomTemplateConfig.valorDescontoMaximoEntrega = faixa.valor"
        )
          span.templateConfirm__regra-label {{ faixa.label }}
          span.templateConfirm__regra-desc {{ faixa.cobertura }}
        button.templateConfirm__regra-btn(
          type="button",
          :class="{ 'templateConfirm__regra-btn--active': cupomTemplateConfig.regraDescontoEntrega === 'total' }",
          @click="cupomTemplateConfig.regraDescontoEntrega = 'total'; cupomTemplateConfig.valorDescontoMaximoEntrega = null"
        )
          span.templateConfirm__regra-label 100% grátis
          span.templateConfirm__regra-desc Sem limite de valor
    .templateConfirm__alert
      v-icon(style="color:#b45309;font-size:18px;flex-shrink:0;margin-top:1px;") warning
      span(v-if="isCardapioDigital") O desconto é de responsabilidade do estabelecimento.
      span(v-else) O desconto é concedido pelo estabelecimento sem possibilidade de ressarcimento pelo Bigou.
    v-card-actions.pt-3.pb-4.px-4
      v-btn(flat, @click="aberto = false") Voltar
      v-spacer
      v-tooltip(top, :disabled="!bloqueio.ativo")
        span(slot="activator")
          v-btn.elevation-0.white--text.Poppins(
            style="background-color:#1d9a5a;border-radius:10px;text-transform:none;font-weight:700;",
            :loading="loading",
            :disabled="bloqueio.ativo || loadingMetricas",
            @click="ativarTemplate()"
          )
            v-icon(left, small) check
            | Ativar cupom
        span(v-if="bloqueio.ativo") {{ bloqueio.motivo.mensagem }}
</template>

<script>
import _ from 'lodash';
import { gerarCodigoCupom, montarPayloadCupom } from '@/util/cupom';

export default {
  name: 'DialogAtivarCupomTemplate',
  props: {
    estabelecimento: { type: Object, default: null },
    cupons: { type: Array, default: () => [] },
    bloqueio: { type: Object, default: () => ({ ativo: false, motivo: null }) },
    metricas28d: { type: Object, default: null },
    bairrosEstabelecimento: { type: Array, default: () => [] },
    isCardapioDigital: { type: Boolean, default: false },
    loadingBairros: { type: Boolean, default: false },
    loadingMetricas: { type: Boolean, default: false },
  },
  data() {
    return {
      aberto: false,
      loading: false,
      cupomTemplateSelecionado: null,
      cupomTemplateConfig: {
        codigo: '',
        vigencia: 'indeterminado',
        quantidade: 1000,
        tipo_quantidade: 'unica',
        regraDescontoEntrega: null,
        valorDescontoMaximoEntrega: null,
      },
    };
  },
  computed: {
    faixasDescontoEntrega() {
      const bairros = this.bairrosEstabelecimento.filter(b => b.valor > 0);
      let valores = bairros.map(b => Number(b.valor)).sort((a, b) => a - b);
      if (!valores.length) {
        const m = this.metricas28d;
        if (m && m.taxaMedia > 0) {
          valores = [m.taxaMedia];
        } else {
          return [
            { valor: 5, label: 'Até R$5,00', cobertura: 'Desconto parcial' },
            { valor: 8, label: 'Até R$8,00', cobertura: 'Desconto moderado' },
            { valor: 12, label: 'Até R$12,00', cobertura: 'Desconto amplo' },
          ];
        }
      }
      const percentil = (arr, p) => {
        const idx = Math.ceil(p * arr.length) - 1;
        return arr[Math.max(0, idx)];
      };
      const arredondar = (v) => Math.round(v * 2) / 2;
      const p50 = arredondar(percentil(valores, 0.5));
      const p75 = arredondar(percentil(valores, 0.75));
      const max = arredondar(valores[valores.length - 1]);
      const totalBairros = valores.length;
      const coberturaLabel = (limite) => {
        const cobertos = valores.filter(v => v <= limite).length;
        const pct = Math.round((cobertos / totalBairros) * 100);
        return `Cobre ${pct}% dos bairros`;
      };
      const faixas = [];
      const usados = new Set();
      if (p50 > 0 && !usados.has(p50)) {
        usados.add(p50);
        faixas.push({ valor: p50, label: `Até R$${p50.toFixed(2).replace('.', ',')}`, cobertura: coberturaLabel(p50) });
      }
      if (p75 > 0 && !usados.has(p75)) {
        usados.add(p75);
        faixas.push({ valor: p75, label: `Até R$${p75.toFixed(2).replace('.', ',')}`, cobertura: coberturaLabel(p75) });
      }
      if (max > 0 && !usados.has(max)) {
        usados.add(max);
        faixas.push({ valor: max, label: `Até R$${max.toFixed(2).replace('.', ',')}`, cobertura: coberturaLabel(max) });
      }
      return faixas.length ? faixas : [{ valor: max || 10, label: `Até R$${(max || 10).toFixed(2).replace('.', ',')}`, cobertura: 'Cobre todos os bairros' }];
    },
    vigenciaLabel() {
      const v = this.cupomTemplateConfig.vigencia;
      if (v === 'indeterminado') return 'Contínuo';
      const hoje = this.$dayjs();
      let fim;
      if (v === 'fim_mes') fim = hoje.endOf('month');
      else if (v === 'fim_semana') fim = hoje.endOf('week');
      else if (v === '7dias') fim = hoje.add(7, 'day');
      return 'Até ' + fim.format('DD/MM/YYYY');
    },
  },
  methods: {
    open(cupom) {
      if (this.bloqueio.ativo) return;
      this.cupomTemplateSelecionado = cupom;
      this.cupomTemplateConfig = {
        codigo: gerarCodigoCupom(cupom, this.estabelecimento && this.estabelecimento.nome),
        vigencia: 'indeterminado',
        quantidade: 10000,
        tipo_quantidade: cupom.primeiro_pedido_estabelecimento ? 'unica' : 'mensal',
        regraDescontoEntrega: null,
        valorDescontoMaximoEntrega: null,
      };
      this.$firebase.logEvent('coupon_template_selected', {
        template_id: cupom.id,
        template_type: cupom.tipo,
        template_value: cupom.valor_desconto,
        is_intelligent: !!cupom.inteligente,
        establishment_id: this.estabelecimento ? this.estabelecimento.id : null,
      });
      this.aberto = true;
    },
    _calcularDatasVigencia() {
      const v = this.cupomTemplateConfig.vigencia;
      if (v === 'indeterminado') return { vigencia: 0, data_inicio: null, data_fim: null };
      const hoje = this.$dayjs();
      let fim;
      if (v === 'fim_mes') fim = hoje.endOf('month');
      else if (v === 'fim_semana') fim = hoje.endOf('week');
      else if (v === '7dias') fim = hoje.add(7, 'day');
      return {
        vigencia: 1,
        data_inicio: hoje.format('YYYY-MM-DD'),
        data_fim: fim.format('YYYY-MM-DD'),
      };
    },
    async ativarTemplate() {
      if (this.bloqueio.ativo) {
        window.getApp.$emit('APP_ALERT', {
          color: 'red',
          text: this.bloqueio.motivo.mensagem,
        });
        return;
      }
      const cupom = { ...this.cupomTemplateSelecionado };
      if (cupom.entrega_gratis && !this.cupomTemplateConfig.regraDescontoEntrega) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Selecione o limite de desconto na entrega.' });
        return;
      }
      const datas = this._calcularDatasVigencia();
      const isMensal = this.cupomTemplateConfig.tipo_quantidade === 'mensal';
      cupom.codigo = this.cupomTemplateConfig.codigo.toUpperCase();
      cupom.quantidade = this.cupomTemplateConfig.quantidade;
      cupom.quantidade_usuario = 1;
      cupom.vigencia = datas.vigencia;
      cupom.data_inicio = datas.data_inicio;
      cupom.data_fim = datas.data_fim;
      cupom.tipo_quantidade_total = isMensal ? 2 : 0;
      cupom.tipo_quantidade_usuario = isMensal ? 2 : 0;
      if (cupom.entrega_gratis) {
        if (this.cupomTemplateConfig.regraDescontoEntrega === 'limitado') {
          cupom.valor_desconto_maximo = this.cupomTemplateConfig.valorDescontoMaximoEntrega;
        } else {
          cupom.valor_desconto_maximo = null;
        }
      }
      if (this.cupomTemplateSelecionado.destaque) {
        cupom.destaque = 1;
      }
      // Todos os dias da semana (0=domingo a 6=sabado)
      cupom.dias_semana = '0,1,2,3,4,5,6';
      await this.saveCupom(cupom);
    },
    async saveCupom(cupom) {
      const vm = this;
      try {
        let codeValid = Boolean(cupom.codigo && cupom.codigo.length >= 5);
        if (!codeValid) return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'O código não pode ter menos de 5 caracteres.' });
        if (_.find(vm.cupons, o =>
          o.id !== cupom.id &&
          o.codigo === cupom.codigo.toUpperCase() &&
          o.ativo === 1 &&
          o.disponiveis > 0 &&
          o.status === 1
        )) {
          return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Já existe um cupom com o mesmo código informado, altere o código ou desative-o antes de cadastrar um novo.' });
        }
        vm.loading = true;
        const obj = montarPayloadCupom(cupom, {
          fromTemplate: true,
          estabelecimento: vm.estabelecimento,
          isCardapioDigital: vm.isCardapioDigital,
        });
        await vm.$axios.post('/cupom-desconto', obj);
        vm.$firebase.logEvent('coupon_created', {
          from_template: true,
          coupon_type: cupom.tipo_desconto,
          coupon_code: obj.codigo,
          establishment_id: vm.estabelecimento ? vm.estabelecimento.id : null,
        });
        vm.loading = false;
        vm.aberto = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Cupom salvo com sucesso!' });
        vm.$emit('saved');
        vm.$emit('ativado', {
          ...obj,
          entrega_gratis: cupom.entrega_gratis,
          taxa_entrega: cupom.taxa_entrega,
        });
      } catch (error) {
        console.log(error);
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao cadastrar o cupom de desconto!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
// ─── Template Confirm Dialog ─────────────────────────────────────────────────
.templateConfirm__header {
  padding: 24px 20px 20px;
  text-align: center;
  border-radius: 11px 11px 0 0;
}
.templateConfirm__title {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  font-family: 'Poppins', sans-serif;
}
.templateConfirm__valor {
  font-size: 42px;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1;
  letter-spacing: -2px;
}
.templateConfirm__valor-label {
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 6px;
  font-family: 'Poppins', sans-serif;
}
.templateConfirm__rows {
  padding: 0 20px;
}
.templateConfirm__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
}
.templateConfirm__row-label {
  font-size: 13px;
  color: #888;
  font-family: 'Poppins', sans-serif;
}
.templateConfirm__row-value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}
.templateConfirm__alert {
  margin: 12px 20px 4px;
  background: #fff8e1;
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 12px;
  color: #7a5c00;
  font-family: 'Poppins', sans-serif;
  line-height: 1.5;
}
.templateConfirm__regra-entrega {
  margin: 8px 20px 0;
  padding: 14px 0 4px;
  border-top: 1px solid #eee;
}
.templateConfirm__regra-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 2px;
}
.templateConfirm__regra-hint {
  font-size: 11px;
  color: #666;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 10px;
}
.templateConfirm__regra-opcoes {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.templateConfirm__regra-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f5f5;
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: 'Poppins', sans-serif;
  text-align: left;
}
.templateConfirm__regra-btn:hover {
  background: #eef7f1;
  border-color: #b8dfc7;
}
.templateConfirm__regra-btn--active {
  background: #eef7f1;
  border-color: #1d9a5a;
}
.templateConfirm__regra-label {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}
.templateConfirm__regra-btn--active .templateConfirm__regra-label {
  color: #1d9a5a;
}
.templateConfirm__regra-desc {
  font-size: 11px;
  color: #888;
  font-weight: 400;
}
.templateConfirm__regra-btn--active .templateConfirm__regra-desc {
  color: #2dab6a;
}
</style>
